import { HTMLAttributes } from 'react';

import { cn } from 'styles';

export function TwoColumnWrapper({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'grid grid-cols-[1fr_minmax(auto,450px)] gap-6 tablet:flex tablet:flex-col',
        className,
      )}
      {...props}
    />
  );
}
